import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo-spectrespecs_00.jpg";

const data: ReplicaItemType = {
  id: "the-quibbler-v1-spectrespecs-grade-b",
  name: "The Quibbler v1 - Spectrespecs (Grade B)",
  nameFormatted: {
    primary: "Grade B",
    secondary: "The Quibbler v1",
    tertiary: "Spectrespecs",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
